<template>
  <pl-dialog title="Poll Details" :size="'md'" :disableOutsideClick="true" @close="$emit('close')">
    <body class="px-7 py-4 flex-grow overflow-y-auto">
      <p class="text-lg font-semibold">{{ selectedPoll.question }}</p>
      <div v-for="(answer, index) in selectedPoll.answers" :key="`voting-${answer}-${index}`">
        <div class="relative ellipsis-text w-full rounded h-10 px-3 mt-4 flex items-center justify-between bg-gray-100" :class="{ 'font-semibold': user_selections.includes(answer) }">
          <div class="rounded absolute h-full left-0 bg-primary" :class="{'rounded-tr-none rounded-br-none': (vote_counts[answer] * 100 || 0) / total_votes_array.length < 100 }"
            :style="[{width: (vote_counts[answer] * 100 || 0) / total_votes_array.length + '%' }]"
          />
          <span class="truncate z-10">{{ answer }}</span>
          <div class="truncate z-10">
            <span class="text-gray-500 text-xs mr-2">
              {{ vote_counts[answer] || '0' }}
              {{ vote_counts[answer] === 1 ? 'vote' : 'votes' }}
            </span>
            <span>{{ Math.round((vote_counts[answer] * 100 || 0) / (total_votes_array.length || 1)) + '%' }}</span>
          </div>
        </div>
        <div v-if="hasTeacherPermissionsInCourse && selectedPoll.votes && selectedPoll.votes.length && vote_counts[answer] > 0" class="px-3" :key="componentKey">
          <button class="m-0 text-xs text-gray-500" @click="showStudentVotes(`voting-${answer}-${index}`)">
            Respondents
            <i v-if="!opened_votes[`voting-${answer}-${index}`]" class="fas fa-angle-down p-1"/>
            <i v-else class="fas fa-angle-up p-1" />
          </button>
        </div>
        <div
          v-for="vote in selectedPoll.votes"
          :key="vote.user_id"
          v-if="
            hasTeacherPermissionsInCourse &&
            vote.selections[0] === answer &&
            opened_votes[`voting-${answer}-${index}`]
          "
          class="flex w-full items-center px-3 py-2"
        >
          <div
            class="w-7 h-7 rounded-full mr-2"
            :style="{
              backgroundImage:
                'url(' + encodeImageURI(vote.user.avatar_url) + ')',
              'background-size': 'cover',
              'background-position': 'center',
            }"
          ></div>
          <div class="text-xs text-gray-500 mx-1">{{ vote.user.name }}</div>
        </div>
      </div>
    </body>
    <footer class="flex justify-between items-center pt-5 pb-5 px-7">
      <div>
        <button v-if="!realTimeVote" @click="closePollDialog()" class=" py-2 px-5 bg-gray-100 hover:bg-gray-200 rounded text-gray-500 font-semibold mr-2">
          <i class="fas fa-arrow-left mr-2" /> Back To Polls
        </button>
      </div>
      <button @click="$emit('deletePoll')" v-if="hasTeacherPermissionsInCourse" class="py-2 px-5 bg-red-400 rounded text-white font-semibold">
        Delete
      </button>
    </footer>
  </pl-dialog>
</template>
<script>
  import { mapGetters } from 'vuex';
  import find from 'lodash/find';
  import countBy from 'lodash/countBy';
  import { encodeImageUrl } from 'utils/encodeImage';
  import { EventBus } from '../../utils/event-bus';

  export default {
    data() {
      return {
        opened_votes: {},
        componentKey: 0,
      };
    },
    computed: {
      ...mapGetters(['getProfile', 'hasTeacherPermissionsInCourse']),
      total_votes_array() {
        let total = [];
        if (this.selectedPoll.votes) {
          this.selectedPoll.votes.forEach((vote) => {
            total = total.concat(vote.selections);
          });
        }
        return total;
      },
      user_selections() {
        const vote = find(
          this.selectedPoll.votes,
          (vote) => vote.user_id === this.getProfile.id
        );
        return vote ? vote.selections : [];
      },
      vote_counts() {
        return countBy(this.total_votes_array) || {};
      },
      highest_vote_count() {
        const values = Object.values(this.vote_counts);
        return Math.max(...values);
      },
    },
    props: {
      showPollIsOpenText: {
        type: Boolean,
        default: true,
      },
      columnFlex: {
        type: Boolean,
        default: true,
      },
      selectedPoll: {
        type: Object,
        default: () => ({
          id: '',
          question: '',
          answers: [],
        }),
      },
      realTimeVote: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      encodeImageURI(image_url) {
        return encodeImageUrl(image_url);
      },
      getAnswers() {
        let answers = [];
        if (this.selectedPoll.answers) {
          this.selectedPoll.answers.forEach((answer, index) => {
            answers.push(`voting-${answer}-${index}`);
          });
        }
        if (answers.length) {
          answers.forEach((a) => (this.opened_votes[a] = false));
        }
      },
      showStudentVotes(answer) {
        this.componentKey += 1;
        if (this.opened_votes[answer]) {
          this.opened_votes[answer] = false;
          return;
        }
        this.opened_votes[answer] = true;
      },
      closePollDialog() {
        this.$emit('closePollDialog');
      },
    },
    created() {
      this.getAnswers();
    },
    mounted() {
      EventBus.$on('close_dialog_poll', () => {
        this.closePollDialog();
      });
    },
  };
</script>



// WEBPACK FOOTER //
// polls.results.vue?7cf247eb